import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ExpenseApprovePage } from '@/features/billing/pages/ExpenseApprovePage';
import { expenseApprovalSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/expense-approve')({
  validateSearch: expenseApprovalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Expense Approve">
      <Suspense fallback={<PageLoader />}>
        <ExpenseApprovePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
